export default "__VITE_ASSET__vTHzyhDb__"